import React from 'react';
import MaterialCardActions from '@mui/material/CardActions';
import {Divider} from '../Divider/Divider';
import type {CardActionsProps as MaterialCardActionsProps} from '@mui/material/CardActions';
import {styled} from '@mui/material/styles';
import {excludeComponentProps} from '../utils/excludeComponentProps';

type FuelJustifyContent = 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';

type FuelDivider = 'none' | 'top' | 'bottom';

type FuelBackgroundColor = 'gray' | string;

export interface CardActionsProps extends MaterialCardActionsProps {
    /**
     * Dense padding
     * @default false
     */
    dense?: boolean;
    /**
     * Includes divider
     * @default 'none'
     */
    divider?: FuelDivider;
    /**
     * Position of items within CardActions
     * @default 'flex-start'
     */
    justifyContent?: FuelJustifyContent;
    /**
     * Background color
     * @default 'transparent'
     */
    bgcolor?: FuelBackgroundColor;
}

const StyledCardActions = styled(MaterialCardActions, {
    ...excludeComponentProps('justifyContent', 'dense')
})<CardActionsProps>(({
    theme, dense, bgcolor, justifyContent: justifyContentProp
}) => ({
    padding: '1rem',
    ...dense && {
        padding: '.5rem'
    },
    ...justifyContentProp && {
        justifyContent: justifyContentProp
    },
    ...bgcolor && {
        backgroundColor: bgcolor
    },
    ...bgcolor === 'gray' && {
        backgroundColor: theme.tokens.FuelColorGray50
    }
}));

export const CardActions = React.forwardRef<any, CardActionsProps>(
    (
        {
            dense = false,
            divider = 'none',
            bgcolor,
            justifyContent = 'flex-start',
            children,
            ...props
        },
        ref
    ) => {
        return (
            <>
                { divider === 'top' && <Divider/> }
                <StyledCardActions
                    bgcolor={bgcolor}
                    dense={dense}
                    justifyContent={justifyContent}
                    ref={ref}
                    {...props}
                >
                    {children}
                </StyledCardActions>
                { divider === 'bottom' && <Divider/> }
            </>
        );
    });

CardActions.displayName = 'CardActions';
